module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/institutions/icon_arrow--white-820a29347364dcb3defd0035e47f590e.svg";